import isEmpty from 'lodash/isEmpty';
import { setCookie, getCookie } from './trainUtils';
import {
  RAILS_SESSION_ID_EXPIRY_IN_MINUTES,
  RAILS_SESSION_ID_KEY
} from "../constants/TrainConstants";

export const { resetSessionID, getSessionID } = (() => {
  const randomString = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);

  const generateRandomID = () => {
    const id = `${randomString() +
      randomString()}-${randomString()}-${randomString()}-${randomString()}-${randomString() +
      randomString() +
      randomString()}`;
    return id;
  };

  const generateNewSessionID = () => {
    const id = getCookie("dvid") ?? generateRandomID();
    const sessionID = `${id}_dweb_${Date.now()}_${randomString()}`;
    return sessionID;
  };

  const getCurrentSessionID = () => {
    try {
      const currentSessionID = getCookie(RAILS_SESSION_ID_KEY) ?? "";
      return currentSessionID;
    } catch (err) {
      console.log("Error in getting current session ID: ", err);
      return generateNewSessionID();
    }
  };

  const resetSessionID = () => {
    try {
      setCookie(RAILS_SESSION_ID_KEY, generateNewSessionID(), 365);
    } catch (err) {
      console.log("Error in resetting session ID: ", err);
    }
  };

  const getSessionID = () => {
    try {
      const currentSessionID = getCurrentSessionID();
      const currentTime = Date.now();
      const sessionIDCreationTime = Number(currentSessionID?.split("_")?.[2]);
      const timeElapsedSinceSessionIdCreation =
        currentTime - sessionIDCreationTime;
      const sessionIDExpired = isEmpty(currentSessionID)
        ? true
        : timeElapsedSinceSessionIdCreation >= RAILS_SESSION_ID_EXPIRY_IN_MINUTES * 60 * 1000;
      if (sessionIDExpired)
        setCookie(RAILS_SESSION_ID_KEY, generateNewSessionID(), 365);
    } catch (err) {
      console.log("Error in getting session ID: ", err);
    } finally {
      const sessionID = getCurrentSessionID();
      return isEmpty(sessionID) ? generateNewSessionID() : sessionID;
    }
  };

  return { resetSessionID, getSessionID, };
})();